const ROLE_ADMINISTRATOR = 'beststart.winz.admin';
const ROLE_SUPER_ADMINISTRATOR = 'beststart.winz.superadmin';
const ROLE_READ_ONLY = 'beststart.winz.readonly';
const ALL_ROLES = [
    ROLE_ADMINISTRATOR,
    ROLE_SUPER_ADMINISTRATOR,
    ROLE_READ_ONLY,
];
const ADMINS = [
    ROLE_ADMINISTRATOR,
    ROLE_SUPER_ADMINISTRATOR,
]
const roles = {
    ROLE_SUPER_ADMINISTRATOR,
    ROLE_ADMINISTRATOR,
    ROLE_READ_ONLY,
    ALL_ROLES,
    ADMINS,
};

export default roles;